import { render, staticRenderFns } from "./MyProjectDetails.vue?vue&type=template&id=97ec64c4&scoped=true&"
import script from "./MyProjectDetails.vue?vue&type=script&lang=js&"
export * from "./MyProjectDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyProjectDetails.vue?vue&type=style&index=0&id=97ec64c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ec64c4",
  null
  
)

export default component.exports